import jwt from "jsonwebtoken";
import CryptoJSUtils from "./crypto-js-utils";
import CryptoJS from "crypto-js";

const serviceConfig = {
  securityKey: process.env.VUE_APP_SLEEK_SITE_ONBOARDING_SECURITY_KEY || "onboarding-local-dummykey",
  algorithm: process.env.VUE_APP_SLEEK_SITE_ONBOARDING_SECURITY_ALGORITHM || "HS256", // default HS256
  encryptionKey: process.env.VUE_APP_SLEEK_SITE_ONBOARDING_ENCRYPTION_KEY || "onboarding-local-encpkey",
};

const formatConfig = {
  keySize: 128 / 8,
  // eslint-disable-next-line id-length
  iv: serviceConfig.encryptionKey,
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7,
};

// Encryption and Decryption of data
const encryptJWTData = (payload) => CryptoJSUtils.encryptData(payload, serviceConfig.encryptionKey, formatConfig);

const decryptJWTData = (payload) => CryptoJSUtils.decryptData(payload, serviceConfig.encryptionKey, formatConfig);

// Generation of Token
const generateJwtToken = (payload, serviceExpiration) => {
  return jwt.sign(payload, serviceConfig.securityKey, { expiresIn: serviceExpiration });
};

// Verify Token
const verifyToken = async (token) => {
  try {
    const decoded = jwt.verify(token, serviceConfig.securityKey);
    return { isValid: true, isExpired: false, decoded };
  } catch (error) {
    return {
      isValid: false,
      isExpired: error.message === "jwt expired",
      decoded: null,
    };
  }
};

const verifyAccessControlToken = async (token) => {
  try {
    const decoded = jwt.decode(token);
    if (decoded.exp) {
      if (decoded.exp <= new Date()/1000) {
        return { isValid: false, isExpired: true, decoded };
      } else {
        return { isValid: true, isExpired: false, decoded };
      }
    } else {
      return { isValid: false, isExpired: false, decoded };
    }
  } catch (error) {
    return {
      isValid: false,
      isExpired: error.message === "jwt expired",
      decoded: null,
    };
  }
};

export default {
  encryptJWTData,
  decryptJWTData,
  generateJwtToken,
  verifyToken,
  verifyAccessControlToken
};
